var Orientation = {
  PORTRAIT : false,
  LANDSCAPE : true
};

module.exports = Orientation;


// WEBPACK FOOTER //
// ./src/componentes/lib/rtf/orientation.js